import { DocumentsTableColumnModel } from '../../../shared/components';
import { TableAlignEnum } from '../../../shared/components';
import { BinLocationsTabsEnum } from '../../enums';

export function getConfigColumns(): DocumentsTableColumnModel[] {
  return [
    {
      name: '#',
      prop: 'acc 1',
      width: '40px'
    },
    {
      name: 'COLUMN.BIN_LOCATION',
      prop: 'binLocation',
      sortable: true,
      width: '160px'
    },
    {
      name: 'COLUMN.TYPE',
      prop: 'typeLabel',
      sortable: true,
      customizable: true,
      width: '1fr',
      minWidth: '200px'
    },
    {
      name: 'COLUMN.STATUS',
      prop: 'status',
      cell: 'status',
      sortable: true,
      customizable: true,
      width: '124px',
      alignment: TableAlignEnum.CENTER
    },
    {
      name: 'POSITIONS.PRODUCTS',
      prop: 'productsCount',
      sortable: true,
      customizable: true,
      width: '160px',
      alignment: TableAlignEnum.RIGHT,
      showWithStatuses: [
        BinLocationsTabsEnum.GENERAL_STOCK,
        BinLocationsTabsEnum.RETURNS_STOCK,
      ]
    },
    {
      name: 'COLUMN.CREATED',
      prop: 'createdAt',
      cell: 'dateTime',
      sortable: true,
      customizable: true,
      width: '160px'
    },
    {
      name: 'COLUMN.LAST_ACTIVITY',
      prop: 'lastActivity',
      cell: 'dateTime',
      sortable: true,
      customizable: true,
      width: '160px',
      showWithStatuses: [
        BinLocationsTabsEnum.GENERAL_STOCK,
        BinLocationsTabsEnum.RETURNS_STOCK,
      ]
    },
    {
      name: 'COLUMN.DELETED',
      prop: 'deletedAt',
      cell: 'dateTime',
      sortable: true,
      customizable: true,
      width: '160px',
      showWithStatuses: [
        BinLocationsTabsEnum.DELETED,
      ]
    },
    {
      name: null,
      prop: null,
      cell: 'expand',
      width: '64px',
      sticky: 'right',
      showWithStatuses: [
        BinLocationsTabsEnum.GENERAL_STOCK,
        BinLocationsTabsEnum.RETURNS_STOCK,
      ]
    }
  ];
}
